var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIconTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.039,
    height: 18.048,
    viewBox: "22495.418 -7340.773 14.039 18.048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22496.42-7324.73c0 1.102.903 2.005 2.006 2.005h8.021a2.011 2.011 0 0 0 2.006-2.006v-12.032h-12.032v12.032Zm13.035-15.04h-3.51l-1.002-1.003h-5.013l-1.003 1.002h-3.509v2.006h14.037v-2.006Z",
    fill: "#a1a3ef",
    fillRule: "evenodd",
    "data-name": "Icon material-delete"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconTable);
export default __webpack_public_path__ + "static/media/deleteIconTable.e0c1f716d1c42e54930931492c2ca66b.svg";
export { ForwardRef as ReactComponent };